"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnAppIsReadyBase = void 0;
const Entities_1 = require("../../Entities");
class OnAppIsReadyBase extends Entities_1.RequestHandler {
    constructor(hostHandler) {
        super();
        this.requestType = 'APP_IS_READY';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version) => {
            if (version === 1) {
                this.action();
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.OnAppIsReadyBase = OnAppIsReadyBase;
